import * as s from "react";
import E from "react";
import { jsx as R } from "react/jsx-runtime";
import * as g from "react-dom";
function z(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function G(e, t) {
  const n = s.createContext(t), r = (c) => {
    const { children: l, ...i } = c, u = s.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ R(n.Provider, { value: u, children: l });
  };
  r.displayName = e + "Provider";
  function o(c) {
    const l = s.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${c}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function $(e, t = []) {
  let n = [];
  function r(c, l) {
    const i = s.createContext(l), u = n.length;
    n = [...n, l];
    const d = (f) => {
      var S;
      const { scope: p, children: h, ...x } = f, m = ((S = p == null ? void 0 : p[e]) == null ? void 0 : S[u]) || i, C = s.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ R(m.Provider, { value: C, children: h });
    };
    d.displayName = c + "Provider";
    function a(f, p) {
      var m;
      const h = ((m = p == null ? void 0 : p[e]) == null ? void 0 : m[u]) || i, x = s.useContext(h);
      if (x) return x;
      if (l !== void 0) return l;
      throw new Error(`\`${f}\` must be used within \`${c}\``);
    }
    return [d, a];
  }
  const o = () => {
    const c = n.map((l) => s.createContext(l));
    return function(i) {
      const u = (i == null ? void 0 : i[e]) || c;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: u } }),
        [i, u]
      );
    };
  };
  return o.scopeName = e, [r, A(o, ...t)];
}
function A(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(c) {
      const l = r.reduce((i, { useScope: u, scopeName: d }) => {
        const f = u(c)[`__scope${d}`];
        return { ...i, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function _(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function N(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const c = _(o, t);
      return !n && typeof c == "function" && (n = !0), c;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const c = r[o];
          typeof c == "function" ? c() : _(e[o], null);
        }
      };
  };
}
function M(...e) {
  return s.useCallback(N(...e), e);
}
// @__NO_SIDE_EFFECTS__
function I(e) {
  const t = /* @__PURE__ */ T(e), n = s.forwardRef((r, o) => {
    const { children: c, ...l } = r, i = s.Children.toArray(c), u = i.find(L);
    if (u) {
      const d = u.props.children, a = i.map((f) => f === u ? s.Children.count(d) > 1 ? s.Children.only(null) : s.isValidElement(d) ? d.props.children : null : f);
      return /* @__PURE__ */ R(t, { ...l, ref: o, children: s.isValidElement(d) ? s.cloneElement(d, void 0, a) : null });
    }
    return /* @__PURE__ */ R(t, { ...l, ref: o, children: c });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function T(e) {
  const t = s.forwardRef((n, r) => {
    const { children: o, ...c } = n;
    if (s.isValidElement(o)) {
      const l = V(o), i = j(c, o.props);
      return o.type !== s.Fragment && (i.ref = r ? N(r, l) : l), s.cloneElement(o, i);
    }
    return s.Children.count(o) > 1 ? s.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var D = Symbol("radix.slottable");
function L(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === D;
}
function j(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], c = t[r];
    /^on[A-Z]/.test(r) ? o && c ? n[r] = (...i) => {
      const u = c(...i);
      return o(...i), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...c } : r === "className" && (n[r] = [o, c].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function V(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function J(e) {
  const t = e + "CollectionProvider", [n, r] = $(t), [o, c] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (m) => {
    const { scope: C, children: S } = m, v = E.useRef(null), y = E.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ R(o, { scope: C, itemMap: y, collectionRef: v, children: S });
  };
  l.displayName = t;
  const i = e + "CollectionSlot", u = /* @__PURE__ */ I(i), d = E.forwardRef(
    (m, C) => {
      const { scope: S, children: v } = m, y = c(i, S), P = M(C, y.collectionRef);
      return /* @__PURE__ */ R(u, { ref: P, children: v });
    }
  );
  d.displayName = i;
  const a = e + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ I(a), h = E.forwardRef(
    (m, C) => {
      const { scope: S, children: v, ...y } = m, P = E.useRef(null), b = M(C, P), w = c(a, S);
      return E.useEffect(() => (w.itemMap.set(P, { ref: P, ...y }), () => void w.itemMap.delete(P))), /* @__PURE__ */ R(p, { [f]: "", ref: b, children: v });
    }
  );
  h.displayName = a;
  function x(m) {
    const C = c(e + "CollectionConsumer", m);
    return E.useCallback(() => {
      const v = C.collectionRef.current;
      if (!v) return [];
      const y = Array.from(v.querySelectorAll(`[${f}]`));
      return Array.from(C.itemMap.values()).sort(
        (w, O) => y.indexOf(w.ref.current) - y.indexOf(O.ref.current)
      );
    }, [C.collectionRef, C.itemMap]);
  }
  return [
    { Provider: l, Slot: d, ItemSlot: h },
    x,
    r
  ];
}
var W = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], K = W.reduce((e, t) => {
  const n = /* @__PURE__ */ I(`Primitive.${t}`), r = s.forwardRef((o, c) => {
    const { asChild: l, ...i } = o, u = l ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R(u, { ...i, ref: c });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Q(e, t) {
  e && g.flushSync(() => e.dispatchEvent(t));
}
function X(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var k = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
}, B = s[" useInsertionEffect ".trim().toString()] || k;
function Y({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, c, l] = F({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, u = i ? e : o;
  {
    const a = s.useRef(e !== void 0);
    s.useEffect(() => {
      const f = a.current;
      f !== i && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), a.current = i;
    }, [i, r]);
  }
  const d = s.useCallback(
    (a) => {
      var f;
      if (i) {
        const p = U(a) ? a(e) : a;
        p !== e && ((f = l.current) == null || f.call(l, p));
      } else
        c(a);
    },
    [i, e, c, l]
  );
  return [u, d];
}
function F({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = s.useState(e), o = s.useRef(n), c = s.useRef(t);
  return B(() => {
    c.current = t;
  }, [t]), s.useEffect(() => {
    var l;
    o.current !== n && ((l = c.current) == null || l.call(c, n), o.current = n);
  }, [n, o]), [n, r, c];
}
function U(e) {
  return typeof e == "function";
}
export {
  K as P,
  J as a,
  z as b,
  $ as c,
  Y as d,
  X as e,
  k as f,
  Q as g,
  I as h,
  N as i,
  G as j,
  M as u
};
